import React from "react";
interface props {
  className: string;
}

function Icon2({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      //   width="32"
      //   height="33"
      className={className}
      fill="none"
      viewBox="0 0 32 33"
    >
      <path
        fill="#666"
        d="M26.354 11.146l-7-7A.5.5 0 0019 4H7a1.5 1.5 0 00-1.5 1.5v22A1.5 1.5 0 007 29h18a1.5 1.5 0 001.5-1.5v-16a.499.499 0 00-.146-.354zM19.5 5.706L24.793 11H19.5V5.706zM25 28H7a.5.5 0 01-.5-.5v-22A.5.5 0 017 5h11.5v6.5a.5.5 0 00.5.5h6.5v15.5a.5.5 0 01-.5.5zm-5.646-7.854a.503.503 0 010 .708l-3 3a.503.503 0 01-.708 0l-3-3a.5.5 0 01.708-.708l2.146 2.146V15.5a.5.5 0 011 0v6.793l2.146-2.147a.503.503 0 01.708 0z"
      ></path>
    </svg>
  );
}

export default Icon2;
